import { loader, showMessage } from "../../components/message"
import { usuario } from "../../usuario"
import { getUrlAction, loginMessage, newPage, errorInput, convertAmericanDateToBR } from "../../utils"
import templateMeusDados from './MeusDados.hbs'

export const MeusDados = () => {
    if (usuario.logado) {

        newPage({
            appbarTitle: 'Meus dados'
        })

        select('.page-body').innerHTML = templateMeusDados({
            usuario,
            masculino: usuario.sexo === 0,
            feminino: usuario.sexo === 1,
            email: usuario.email,
            dataNascimento: convertAmericanDateToBR(usuario.dataNascimento)
        });

        const telefone = select('#meus-dados #telefone')
        const senha = select('#meus-dados #senha')
        const confirmarSenha = select('#meus-dados #confirmar-senha')
        const button = select('#meus-dados #save-data')
        const aniversario = select('#aniversario')
        const email = select('#email')
        const sexoWrapper = select('#meus-dados #sexo')

        $(telefone).mask('(00) 0000-00009')
        $(aniversario).mask('00/00/0000')

        // Remove a mensagem de erro de um campo
        const limparErro = (input) => {
            const wrapper = input.closest('.input-wrapper')
            if (!wrapper) return
            wrapper.classList.remove('input-error')
            const span = wrapper.querySelector('.error-message')
            span && span.remove()
            input.style.borderColor = ''
        }

        // Exibe a mensagem de erro no campo e a remove assim que o usuário digitar
        const marcarErro = (input, mensagem) => {
            const wrapper = input.closest('.input-wrapper')
            if (!wrapper) return
            errorInput(wrapper, mensagem)
            input.style.borderColor = '#ff304f'
            input.addEventListener('input', () => limparErro(input), { once: true })
        }

        // Valida uma data no formato dd/mm/aaaa
        const dataNascimentoValida = (valor) => {
            const [dia, mes, ano] = valor.split('/').map(Number)
            if (!dia || !mes || !ano) return false
            const data = new Date(ano, mes - 1, dia)
            return (
                data.getDate() === dia &&
                data.getMonth() === mes - 1 &&
                data.getFullYear() === ano &&
                ano >= 1900 &&
                data <= new Date()
            )
        }

        const emailValido = (valor) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor)

        // Remove a mensagem de erro do grupo de gênero
        const limparErroSexo = () => {
            sexoWrapper.classList.remove('input-error')
            const span = sexoWrapper.querySelector('.error-message')
            span && span.remove()
        }

        // Limpa o erro de gênero assim que o usuário escolher uma opção
        selectAll('[name="sex"]', sexoWrapper).forEach((radio) =>
            radio.addEventListener('change', limparErroSexo)
        )

        $('.dados-log-out a').on('click', () => {
            const callback = () => {
                $('.message-box button:first-of-type').on('click', () => {
                    window.location = getUrlAction('Account', 'logout')
                })
                $('.message-box button:last-of-type').on('click', () => {
                    select('.message-box').remove()
                })
            }

            showMessage(
                '',
                'Tem certeza que deseja sair?',
                'warning',
                '',
                callback,
                true,
                'small',
                true
            )
        })

        button.classList.remove('btn-disabled')

        button.addEventListener('click', function () {
            // Limpa erros de uma validação anterior
            ;[telefone, aniversario, email, senha, confirmarSenha].forEach(
                (campo) => campo && limparErro(campo)
            )
            limparErroSexo()

            let primeiroInvalido = null
            const invalidar = (input, mensagem) => {
                marcarErro(input, mensagem)
                if (!primeiroInvalido) primeiroInvalido = input
            }

            // Gênero — obrigatório
            const sexoSelecionado = select('[name="sex"]:checked')
            if (!sexoSelecionado) {
                errorInput(sexoWrapper, 'Gênero é obrigatório')
                if (!primeiroInvalido) primeiroInvalido = sexoWrapper
            }

            // Telefone — obrigatório
            if (!telefone.value.trim()) {
                invalidar(telefone, 'Telefone é obrigatório')
            } else if (telefone.value.length < 14) {
                invalidar(telefone, 'Telefone inválido')
            }

            // Data de nascimento — opcional, mas se preenchida deve ser válida
            if (aniversario.value.trim()) {
                if (aniversario.value.length < 10) {
                    invalidar(aniversario, 'Data de nascimento incompleta')
                } else if (!dataNascimentoValida(aniversario.value)) {
                    invalidar(aniversario, 'Data de nascimento inválida')
                }
            }

            // E-mail — opcional, mas se preenchido deve ser válido
            if (email && email.value.trim() && !emailValido(email.value.trim())) {
                invalidar(email, 'E-mail inválido')
            }

            // Senha — opcional; só valida quando o usuário quer alterá-la
            const querAlterarSenha = senha.value || confirmarSenha.value
            if (querAlterarSenha) {
                if (!senha.value) {
                    invalidar(senha, 'Informe a nova senha')
                } else if (senha.value.length < 6) {
                    invalidar(senha, 'A senha deve ter no mínimo 6 caracteres')
                }

                if (!confirmarSenha.value) {
                    invalidar(confirmarSenha, 'Confirme a nova senha')
                } else if (senha.value && senha.value !== confirmarSenha.value) {
                    invalidar(confirmarSenha, 'As senhas não coincidem')
                }
            }

            // Há erros — não envia e foca o primeiro campo inválido
            if (primeiroInvalido) {
                primeiroInvalido.focus()
                return
            }

            const sexo = sexoSelecionado.value

            const cUrl = getUrlAction('Cadastros', 'SetDadosUsuario')
            const emailValue = email ? email.value : ''
            button.innerHTML = loader()
            setTimeout(() => {
                $.ajax({
                    url: cUrl,
                    type: 'POST',
                    data: {
                        telefone: telefone.value,
                        senha: senha.value,
                        confirmaSenha: confirmarSenha.value,
                        sexo: sexo,
                        email: emailValue,
                        dataNascimento: aniversario.value
                    },
                    async: true,
                    success: (response) => {
                        response = JSON.parse(response)
                        button.innerHTML = 'Alterar'
                        showMessage(
                            '',
                            response.msg || (response.lValid ? 'Dados alterados com sucesso!' : 'Erro ao alterar dados!'),
                            response.lValid ? 'success' : 'error',
                            'OK',
                            () => {
                                let buttonOK = select('.message-box button')
                                buttonOK &&
                                    $(buttonOK).on('click', function () {
                                        select('.message-box').remove()
                                    })
                            }
                        )
                    },
                    error: () => {
                        button.innerHTML = 'Alterar'
                    }
                })
            }, 100)
        })


    } else {
        loginMessage()
    }
}
